// @ts-nocheck
/* eslint-disable */
/**
 * Prevod binarnich dat do base64
 * @param  {String} fileType Typ dat
 * @param  {Array} binaryData
 * @returns {String}
 */
Mapy.Util.readBinary = function(file) {
	var slice = function(array) {
		var out = [];
		for (var i = 0; i < array.length; i++) {
			out.push(array[i]);
		}
		return out;
	};

	var promise = new JAK.Promise();

	if ("FileReader" in window && file) {
		var reader = new FileReader();

		reader.onload = function(e) {
			var result = e.target.result;
			var binaryData = new Uint8Array(result);

			promise.fulfill({
				binary: binaryData,
				frpc: slice(binaryData)
			});
		};

		reader.onerror = function(e) {
			promise.reject(e);
		};

		reader.readAsArrayBuffer(file);
	}
	else {
		promise.reject();
	}

	return promise;
};

/**
 * Prevod binarnich dat do base64
 * @param  {String} fileType Typ dat
 * @param  {Array} binaryData
 * @returns {String}
 */
Mapy.Util.fileToBase64 = function(fileType, binaryData) {
	var output = "";

	for (var i = 0; i < binaryData.length; i += 1) {
		output += String.fromCharCode(binaryData[i]);
	}

	return 'data:' + fileType + ';base64,' + btoa(output);
};

/**
 * Search lokace z url | vlastni query preved na objekt klic = hodnota|[hodnoty]
 *
 * @param  {String} [query] vlastni query
 * @returns {Object}
 */
Mapy.Util.searchToObj = function(query) {
	var sp = {};

	(new URLSearchParams(query || location.search.substring(1))).forEach(function(value, key) {
		if (key in sp) {
			if (!Array.isArray(sp[key])) {
				sp[key] = [sp[key]];
			}
			sp[key].push(value);
		} else {
			sp[key] = value;
		}
	});

	return sp;
};

// https://gist.github.com/fupslot/5015897 prevod dataURi na blob
/**
 * Prevod dataURI na Blob
 * @param  {String} dataURI dataURI reprezentace souboru
 * @returns {Blob}
 */
Mapy.Util.dataURItoBlob = function(dataURI) {
	// convert base64 to raw binary data held in a string
	// doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
	var byteString = atob(dataURI.split(',')[1]);

	// separate out the mime component
	var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

	// write the bytes of the string to an ArrayBuffer
	var ab = new ArrayBuffer(byteString.length);
	var ia = new Uint8Array(ab);
	for (var i = 0; i < byteString.length; i++) {
		ia[i] = byteString.charCodeAt(i);
	}

	// write the ArrayBuffer to a blob, and you're done
	var bb = new Blob([ab]);
	return bb;
};
